module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/whiteDown.0166fa40.svg";